module.exports = __webpack_public_path__ + "img/high-school-volunteer-home.62674c11.png";